interface AudioPreviewProps {
  url: string;
  name: string;
  mimeType: string;
}

export function AudioPreview({ url, name, mimeType }: AudioPreviewProps) {
  return (
    <div className="flex flex-col items-center gap-6 px-4">
      {/* Waveform decoration */}
      <div className="flex h-24 items-end gap-1">
        {Array.from({ length: 40 }, (_, i) => {
          const h = 20 + Math.abs(Math.sin(i * 0.7) * 60 + Math.cos(i * 1.3) * 30);
          return (
            <div
              key={i}
              className="w-1.5 rounded-full bg-indigo-500/60"
              style={{ height: `${Math.min(h, 96)}%` }}
            />
          );
        })}
      </div>

      {/* File name */}
      <p className="max-w-sm truncate text-center text-sm text-gray-300">{name}</p>

      {/* Native audio player */}
      <audio
        src={url}
        controls
        autoPlay
        className="w-full max-w-md"
        style={{ colorScheme: "dark" }}
      >
        <source src={url} type={mimeType} />
        Your browser does not support audio playback.
      </audio>
    </div>
  );
}
